import { defineComponent, PropType } from 'vue';
import { MediaUi } from '@/fairplayer/primary/marketplace/exclusives-list/Media.ui';
import { ExclusiveImageVue } from '@/common/primary/fairplayer-image/exclusive-image';

export default defineComponent({
  name: 'ExclusiveMedia',

  components: {
    ExclusiveImageVue,
  },

  props: {
    media: {
      type: Object as PropType<MediaUi>,
      required: true,
    },
  },
});
